/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const invokeBedrock = /* GraphQL */ `
  query InvokeBedrock($prompt: String!) {
    invokeBedrock(prompt: $prompt) {
      body
      statusCode
      __typename
    }
  }
`;

export const invokeBedrockStream = /* GraphQL */ `
  query InvokeBedrockStream($prompt: String!) {
    invokeBedrockStream(prompt: $prompt) {
      connectionId
      statusCode
      __typename
    }
  }
`;

export const callReviseItem = /* GraphQL */ `
  query CallReviseItem($stem: String!, $options: String!, $rationales: String!, $feedback: String!) {
    callReviseItem(stem: $stem, options: $options, rationales: $rationales, feedback: $feedback) {
      body
      statusCode
      __typename
    }
  }
`;

export const callSmartDiff = /* GraphQL */ `
  query CallSmartDiff($beforeModification: String, $afterModification: String) {
    callSmartDiff(beforeModification: $beforeModification, afterModification: $afterModification) {
      body
      statusCode
      __typename
    }
  }
`;

export const getFeedback = /* GraphQL */ `
  query GetFeedback($id: ID!) {
    getFeedback(id: $id) {
      id
      rating
      comment
      timestamp
      createdAt
      updatedAt
    }
  }
`;

export const listFeedbacks = /* GraphQL */ `
  query ListFeedbacks(
    $filter: ModelFeedbackFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listFeedbacks(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        rating
        comment
        timestamp
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

// Manually added — will be auto-generated after `amplify push` with updated schema
export const agenticReview = /* GraphQL */ `
  query AgenticReview($prompt: String!) {
    agenticReview(prompt: $prompt) {
      body
      statusCode
      __typename
    }
  }
`;

// Manually added — will be auto-generated after `amplify push` with updated schema
export const validateUrls = /* GraphQL */ `
  query ValidateUrls($urls: [String!]!) {
    validateUrls(urls: $urls) {
      results {
        url
        statusCode
        valid
        redirectUrl
      }
    }
  }
`;
